import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    width: '100%',
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
    backgroundColor: theme.white,
    borderLeft: `1px solid ${theme.colors.gray2[0]}`,
    borderRight: `1px solid ${theme.colors.gray2[0]}`,
    borderBottom: `1px solid ${theme.colors.gray2[0]}`,
    borderBottomLeftRadius: theme.defaultRadius,
    borderBottomRightRadius: theme.defaultRadius,

    [theme.fn.smallerThan('sm')]: {
      border: 'none',
      borderRadius: 0,
    },
  },
  noTopBorder: {
    borderTop: 'none',
  },
  buttons: {
    gap: theme.other.spacing._24,
  },
  inlineGroup: {
    marginLeft: 'auto',
  },
  exportButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._8}px`,
    margin: `-${theme.other.spacing._4}px -${theme.other.spacing._8}px`,
    border: 'none',
    background: 'none',
    borderRadius: theme.defaultRadius,
    cursor: 'pointer',
    fontFamily: 'Inter, sans-serif',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
    color: theme.colors.gray2[7],
    transition: 'background-color 150ms ease',

    '&:hover': {
      backgroundColor: theme.colors.gray2[0],
    },

    '&:focus': {
      outline: `2px solid ${theme.colors.blue[4]}`,
      outlineOffset: 1,
    },
  },
}));
